<template>
  <div class="graduate-photo-upload-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <AppScrollbar style="height: 100%">
      <div class="main-cont">
        <div class="title">
          <div class="label">
            <i class="el-icon-upload2"></i>
            <span>上传毕业照片（仅支持学号命名）</span>
          </div>
        </div>
        <div class="instruction">
          <p>说明：</p>
          <ul>
            <li>请将照片按照学号命名（如 2021001.jpg）</li>
            <li>仅支持 JPG/JPEG 格式</li>
            <li>将所有照片压缩成 .zip 文件后上传</li>
          </ul>
        </div>
        <div class="upload-cont">
          <DataUnpackModule :unpack-url="uploadUrl"
                            inline></DataUnpackModule>
        </div>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import DataUnpackModule from '../../../../../../elements/DataUnpackModule'
export default {
  name: 'GraduatePhotoUploadMain',
  components: {
    AppScrollbar,
    DataUnpackModule
  },
  data () {
    return {
      uploadUrl: '/workspace/manager/graduate/upload/photo/uploadPhoto',
      loading: false
    }
  }
}
</script>

<style lang="scss">
  .graduate-photo-upload-main {
    height: 100%;
    .main-cont {
      margin: 30px auto;
      width: 540px;
      max-width: 100%;
      & > .title {
        display: flex;
        justify-content: space-between;
        & > .label {
          font-size: 12px;
          i {
            margin-right: 4px;
            font-size: 15px;
            vertical-align: -1px;
          }
        }
      }
      & > .instruction {
        margin-top: 15px;
        padding: 10px 15px;
        background-color: #f5f7fa;
        border-radius: 4px;
        font-size: 12px;
        color: #606266;
        p {
          margin: 0 0 5px 0;
          font-weight: bold;
        }
        ul {
          margin: 0;
          padding-left: 20px;
          li {
            margin: 3px 0;
          }
        }
      }
      & > .upload-cont {
        margin-top: 15px;
      }
    }
  }
</style>
